import React, { useEffect, useMemo, useState } from 'react';
import { v4 } from 'uuid';
import './style.css';
import { styled } from '@mui/material';
interface CountingUpI {
  id: string;
  value: number;
  style: any;
}

const Container = styled('div')`
  @property --num {
    syntax: '<integer>';
    initial-value: 0;
    inherits: false;
  }

  & {
    transition: --num ${(Math.random() * 100) % 3}s;
    counter-set: num var(--num);
  }
  &::after {
    content: counter(num);
  }
  &.start {
    --num: ${(props: any) => props.value};
  }
`;

function CountUp({ id, value, style }: CountingUpI) {
  const [className, setClassName] = useState('countUp');
  useEffect(() => {
    setTimeout(() => {
      setClassName(className + ' start');
    }, 100);
  }, []);
  return (
    <Container id={id} className={className} {...{ value }} style={style} />
  );
}

export { CountUp };
